import './index.css';
import './assets/css/landing-page/main.scss';
import './assets/css/landing-page/landing-page.scss';
import './assets/css/landing-page/background-hero.scss'; // for background image hero
import './assets/css/landing-page/product-page.scss'; // for product page scss
import './assets/css/landing-page/hubungi-kami-and-faq.scss'; // hubungi kami & faq page scss
import './assets/css/landing-page/tentang-kami.scss'; // tentang kami page scss
import './assets/css/override-primereact.scss';
import './assets/js/template/landingpage';
import './assets/js/template/vendor/slick';

import 'primeicons/primeicons.css';

import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from "react-router-dom";

import ReactGA from 'react-ga4';
ReactGA.initialize("G-YQX1B71T6K");

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('root') // Attach to the root element
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
